import { RouteObject } from 'react-router';
import { Outlet } from 'react-router-dom';

import { FeedPage } from './pages/FeedPage';
import { SHOP_CURRENT_ROUTE } from '../../utils/constants';

const routes: RouteObject[] = [
    {
        path: `${SHOP_CURRENT_ROUTE}/feeds`,
        element: <Outlet />,
        children: [{ index: true, element: <FeedPage /> }],
    },
];
export default routes;
